import { useState, useEffect, Fragment } from 'react';
import {useTranslation} from 'react-i18next';

import useFetch from '../../../../../hooks/use-fetch';
import HtmlInput from '../../../../UI/HtmlInput';
import PasswordComponent from '../../../../UI/PasswordComponent';

const RequestDetails = (props) => {
  const {t: translate } = useTranslation();
  const {
    data: forgotPassDetails,
    loading,
    error: serverPassErrors,
    initFunc: requestNewPassword,
  } = useFetch();

  const { apiUrl } = window['appConfig'];
  const queryParams = new URLSearchParams(window.location.search);
  const codeFromUrl = queryParams.get('code');

  const resetFields = {
    password: '',
    repeatPassword: '',
    code: codeFromUrl ?? '',
  };

  const [resetValues, setResetValues] = useState(resetFields);
  const [resetErrors, setResetErrors] = useState({});
  const [forgotPassErrors, setForgotPassErrors] = useState('');
  const [isResendingCode, setIsResendingCode] = useState(false);

  // const [canSubmit, setCanSubmit] = useState(false);

  const emailParam = decodeURI(queryParams.get('email'));
  const userEmail = props.email ? props.email : emailParam;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setResetValues({
      ...resetValues,
      [name]: value,
    });
  };

  const validateSubmit = (e) => {
    e.preventDefault();
    let validationErrors = {};

    //remove all errors
    setForgotPassErrors('');
    setResetErrors({});

    if (!resetValues.password) {
      validationErrors.password = translate('password-required');
    }

    if (!resetValues.repeatPassword) {
      validationErrors.confirm = translate('confirm-password');
    }

    if (resetValues.code === '') {
      validationErrors.code = translate('verification-required');
    }

    setResetErrors({ ...validationErrors });

    if (Object.keys(validationErrors).length === 0) {
      const formObject = {
        email: userEmail,
        password: resetValues.password,
        code: resetValues.code,
      };
      const formBody = Object.keys(formObject)
        .map(
          (key) =>
            encodeURIComponent(key) + '=' + encodeURIComponent(formObject[key]),
        )
        .join('&');

      const forgotPassOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody,
      };

      requestNewPassword({
        url: `${apiUrl}/user/resetpassword`,
        options: forgotPassOptions,
      });
    }
  };

  useEffect(() => {
    if (forgotPassDetails !== null && serverPassErrors === null) {
      props.updateState('complete');
    }

    if (serverPassErrors) {
      setForgotPassErrors(serverPassErrors);
    }
  }, [forgotPassDetails, serverPassErrors]);

  const handleResendCode = async (e) => {
    e.preventDefault();
    setIsResendingCode(true);

    var url = new URL(`${apiUrl}/user/resendpasswordresetcode`);

    var params = { email: userEmail };

    url.search = new URLSearchParams(params).toString();

    fetch(url, {
      method: 'POST',
    });

    setTimeout(function () {
      setIsResendingCode(false);
    }, 1000);
  };

  return (
    <Fragment>
      <h4 className="input-container__heading">{translate('reset-password')}</h4>
      <p className="input-container__description">
        {props.forcedReset ? translate('forced-reset-text') : translate('reset-text')}
      </p>
      <form onSubmit={validateSubmit}>
        <div
          className={`input-row ${resetErrors.code ? 'input-row--error' : ''}`}
        >
          <HtmlInput
            type='number'
            id='code'
            name="code"
            legend={translate('confirmation-code')}
            value={resetValues.code}
            changeCallback={handleChange}
            hasErrors={'code' in resetErrors}
          />
          {resetErrors.code && (
            <p className="input-row__error">{resetErrors.code}</p>
          )}
        </div>
        <PasswordComponent
          setFormErrors={setResetErrors}
          setFormValues={setResetValues}
        />
        <button
          className={`button ${loading ? 'button--loading' : ''}`}
          disabled={loading ? true : false}
        >
          <span>
            {loading ? translate('sending-instructions') : translate('reset-password')}
          </span>
        </button>
        <button
          className="button button--alt button--mt-15 button--small"
          style={{ marginTop: 10 }}
          onClick={handleResendCode}
        >
          {isResendingCode
            ? translate('sending-code')
            : translate('resend-code')}
        </button>
      </form>
      <p className="input-row__error input-row--centre input-row--mt">
        {forgotPassErrors}
      </p>
    </Fragment>
  );
};

export default RequestDetails;
